import React from "react";
import HourInput from "./HourInput";

const INPUT_CLASS = "h-7 text-xs px-1 w-full text-center bg-white";

interface HourRangeInputProps {
    start: number;
    end: number;
    disabled?: boolean;
    onChange: (patch: { start?: number; end?: number }) => void;
}

export default function HourRangeInput({ start, end, disabled = false, onChange }: Readonly<HourRangeInputProps>) {
    return (
        <div className="flex items-center gap-1">
            <HourInput
                valueMinutes={start}
                onChange={(v) => onChange({ start: v })}
                disabled={disabled}
                className={INPUT_CLASS}
                ariaLabel="Heure de début"
            />
            <span className="text-gray-400"> à </span>
            <HourInput
                valueMinutes={end}
                onChange={(v) => onChange({ end: v })}
                disabled={disabled}
                className={INPUT_CLASS}
                ariaLabel="Heure de fin"
            />
        </div>
    );
}
